import { Box, Checkbox } from "@material-ui/core";
import { ErrorMessage } from "formik";
import { FormattedMessage, useIntl } from "react-intl";

interface PrivacyPolicyCheckboxProps {
  PPUrl?: string;
  onChange: (value: boolean) => void;
}

function PrivacyPolicyCheckbox({
  PPUrl,
  onChange,
}: PrivacyPolicyCheckboxProps) {
  const intl = useIntl();

  return (
    <>
      <Box marginTop={"8px"} display={"flex"} alignItems={"start"}>
        <Checkbox
          name="privacyPolicy"
          className={"pqrs-checkbox"}
          onChange={(e) => onChange(e.target.checked)}
          color="default"
          inputProps={{ "aria-label": "primary checkbox" }}
        />
        <label
          className="form-text"
          style={{ marginTop: "10px", marginLeft: "-5px" }}
        >
          <FormattedMessage id="AcceptPolicy" />{" "}
          {PPUrl ? (
            <a
              className="link-policy"
              href={PPUrl}
              target="_blank"
              rel="noreferrer"
            >
              {intl.formatMessage({ id: "PolicyText" })}
            </a>
          ) : (
            <span>{intl.formatMessage({ id: "PolicyText" })}</span>
          )}
        </label>
      </Box>
      <Box paddingLeft={"1rem"}>
        <ErrorMessage
          className="field-error"
          name="privacyPolicy"
          component="div"
        />
      </Box>
    </>
  );
}

export default PrivacyPolicyCheckbox;
